var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "about-us-slider-section"
  }, [_c('slider-wrapper', {
    attrs: {
      "fields": _vm.fields
    }
  }), _c('br'), _c('br'), _c('br'), _c('divider', {
    attrs: {
      "is-bold": true,
      "label": _vm.fields.sections.value.section_one
    }
  }), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "content-wrapper lead-1"
  }, [_vm._v(" " + _vm._s(_vm.fields.sections.value.section_one_text) + " ")])]), _c('divider', {
    attrs: {
      "is-bold": true,
      "label": _vm.fields.sections.value.section_two
    }
  }), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "content-wrapper lead-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.sections.value.section_two_text)
    }
  })]), _c('divider', {
    attrs: {
      "is-bold": true,
      "label": _vm.fields.sections.value.section_three
    }
  }), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "content-wrapper lead-1",
    domProps: {
      "innerHTML": _vm._s(_vm.fields.sections.value.section_three_text)
    }
  })])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }